<template>
  <div class="flex items-center justify-center h-screen px-6 bg-gray-200">
    <div class="w-full max-w-sm p-6 bg-white rounded-md shadow-md">
      <div class="flex items-center justify-center">
        <span class="text-2xl font-semibold text-gray-700">admin</span>
      </div>

      <form class="mt-4" @submit.prevent="login">
        <label class="block">
          <span class="text-sm text-gray-700">Email</span>
          <b-form-input  placeholder="Enter your password" v-model="email"></b-form-input>
        </label>
        <label class="block mt-3">
          <span class="text-sm text-gray-700">Password</span>
          <b-form-input type="password" placeholder="Enter your password" v-model="password"></b-form-input>
        </label>
        <div class="mt-6">
          <button
            class="btn btn-primary w-full"
            v-on:click="submit"
          >
            Sign in
          </button>
        </div>
      </form>
    </div>
  </div>
</template>
<script>
import api from "@/api/api";
import store from "@/store";
import router from "@/router";

export default {
  name: "Login",
  data () {
    return {
      email : "admin@kessam.com",
      password: ""
    }
  },
  methods: {
    submit() {
      api.login.submit({
        email : this.email,
        password : this.password
      }).then((response) => {
        console.error('response', response)
        // response가 직접 객체인지, response.data인지 확인
        const data = response.data || response;
        const {accessToken, refreshToken, isSuperAdmin, role} = data;
        
        store.commit("token/setToken", accessToken)
        store.commit("token/setRefreshToken", refreshToken)
        store.commit("token/setIsSuperAdmin", isSuperAdmin)
        store.commit("token/setRole", role)
        
        // boolean 값을 문자열로 명시적으로 변환
        localStorage.setItem('ACCESS_TOKEN', accessToken)
        localStorage.setItem('REFRESH_TOKEN', refreshToken)
        localStorage.setItem('IS_SUPER_ADMIN', String(isSuperAdmin))
        localStorage.setItem('ROLE', role)
        router.replace("/")
      }).catch((error) => {
        console.log(error)
        const {message} = error.data
        this.$toast.show(message,
          {
            position: "top-right",
            duration: 2000
          })
      })
    }
  }
}
</script>

<style scoped>
.social-btn {
  margin-bottom: 15px;
  font-weight: 400;
  font-size: 16px;
}

.social-btn img {
  height: 32px;
  float: left;
  margin-top: 10px;
}

.social-btn.google {
  margin-top: 7px;
}
.login-link {
  color: rgba(0, 0, 0, 0.65);
  font-size: 14px;
}
</style>